import React from 'react';
import "./todo123.css";
import { Button, Card } from 'react-bootstrap';


function Todo({ todo, index, markTodo, removeTodo }) {
  return (
    <div
      className="todo"
      
    >
      <span style={{ textDecoration: todo.isDone ? "line-through" : "" }}>{todo.text}</span>
      <div>
        <Button variant="outline-success" onClick={() => markTodo(index)}>✓</Button>{' '}
        <Button variant="outline-danger" onClick={() => removeTodo(index)}>✕</Button>
      </div>
    </div>
  );
}

function Todo123() {
  const [todos, setTodos] = React.useState([
    {
      text: "Learn Chess",
      isDone: false
    },
    {
        text: "Go for a run",
        isDone: false
      },
      {
      text: "Read The Infinite Game by Simon Sinek",
      isDone: false
    },
  ]);

  const markTodo = index => {
    const newTodos = [...todos];
    newTodos[index].isDone = true;
    setTodos(newTodos);
  };

  const removeTodo = index => {
    const newTodos = [...todos];
    newTodos.splice(index, 1);
    setTodos(newTodos);
  };

  return (
    <div className="todo1234">
      <div className="container">
        <h1 className="text-center mb-4">This is Day 10. 4 more days to go.</h1>
        <div>
          {todos.map((todo, index) => (
            <Card>
              <Card.Body>
                <Todo
                key={index}
                index={index}
                todo={todo}
                markTodo={markTodo}
                removeTodo={removeTodo}
                />
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Todo123;